module.exports = "/_next/static/images/download-app-large-5d846ce4a19f6671bd4d7f9a79eff817.jpg";